"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var clsx_1 = __importDefault(require("clsx"));
var styles = {
    checkbox: "w-8 border-0 hover:text-gray-700 text-sm focus:outline-none flex-shrink-0",
    disabled: "opacity-25 pointer-events-none cursor-not-allowed",
    enabled: "opacity-100 pointer-events-auto",
};
var CheckBox = function (_a) {
    var onToggle = _a.onToggle, buttonState = _a.buttonState, disabled = _a.disabled;
    var active = ["enabled", "partial"].includes(buttonState);
    var handleToggle = function (e) {
        e.preventDefault();
        onToggle(!active);
    };
    var icon = buttonState === "disabled"
        ? pro_regular_svg_icons_1.faSquare
        : buttonState === "enabled"
            ? pro_solid_svg_icons_1.faCheckSquare
            : pro_solid_svg_icons_1.faMinusSquare;
    return ((0, jsx_runtime_1.jsx)("button", __assign({ onClick: handleToggle, type: "button", className: (0, clsx_1.default)(styles.checkbox, active ? "text-lochivar-default" : "text-rose-darkest", disabled ? styles.disabled : styles.enabled) }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon }, void 0) }), void 0));
};
exports.CheckBox = CheckBox;
